import { render, staticRenderFns } from "./PlantConfigurationUnitsPage.vue?vue&type=template&id=3861554d&"
import script from "./PlantConfigurationUnitsPage.vue?vue&type=script&lang=js&"
export * from "./PlantConfigurationUnitsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports